import { motion } from "framer-motion";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";

export const POPUP_MODAL_OVERLAY_CLASS = "z-[1000]";
export const POPUP_MODAL_CONTAINER_CLASS = "z-[1001]";

const framerSidebarBackground = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0, transition: { delay: 0.1 } },
  transition: { duration: 0.3 },
};

export function PopupModal({
  onClose,
  children,
  contentClassName = "",
  overlayClassName = "",
  containerClassName = "",
  exit = { opacity: 0, transition: { delay: 0.1 } },
  shouldStopPropagation = true,
}: {
  onClose?: () => void;
  children: React.ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  containerClassName?: string;
  shouldStopPropagation?: boolean;
  exit?: any;
}) {
  const handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onClose && onClose();
  };

  const disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.body.style.overflow = "";
  };

  useEffect(() => {
    disableScroll();
    return () => enableScroll();
  }, []);

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <>
      <motion.div
        className={twMerge(
          `fixed top-0 left-0 right-0 bottom-0 bg-black/40 h-[100vh] ${POPUP_MODAL_OVERLAY_CLASS}`,
          overlayClassName
        )}
        onClick={handleClose}
        {...{ ...framerSidebarBackground, exit }}
      />
      <div
        className={twMerge(
          `fixed top-0 left-0 right-0 bottom-0 h-[100vh] flex flex-col justify-center font-outfit ${POPUP_MODAL_CONTAINER_CLASS}`,
          containerClassName
        )}
      >
        <motion.div
          className={`p-8 bg-white rounded-2xl flex-col gap-6 flex ${contentClassName}`}
          {...framerSidebarBackground}
          onClick={(e) => {
            if (shouldStopPropagation) {
              e.stopPropagation();
            }
          }}
        >
          {children}
        </motion.div>
      </div>
    </>,
    document.body
  );
}
